<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "3rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path d="M41.89 41.68l-3.84-24a2 2 0 00-2-1.68h-4.31a8.5 8.5 0 10-15.48 0h-4.33a2 2 0 00-2 1.68l-3.84 24a2 2 0 002 2.32h31.82a2 2 0 002-2.32zM18.5 12.5a5.5 5.5 0 0111 0 5.41 5.41 0 01-1.3 3.5h-8.4a5.41 5.41 0 01-1.3-3.5zM9.26 41l3.52-22h22.44l3.52 22z"/></svg>